import Api from 'api/api';

class BudgetApi {
    getMyBudget(year, month, cancelToken) {
        return Api.get(`/budget/my/${year}/${month}`, {
            cancelToken,
        });
    }

    copyLastMonth(year, month, cancelToken) {
        return Api.post(`/budget/my/${year}/${month}/copy_last_month`, {
            cancelToken,
        });
    }
}

export default new BudgetApi();


// WEBPACK FOOTER //
// ./src/api/budget.js